const fontsKeys = {
  base: ['fonts'] as const,
  uploaded: () => [...fontsKeys.base, 'uploaded'] as const,
  byId: (fontId: string) => [...fontsKeys.base, fontId] as const,
};

export default fontsKeys;
